

































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Title from '@/components/atoms/Title.vue';
import BtnBase from '@/components/atoms/BtnBase.vue';
import { CustomerSignupRequest } from '@/types/api/types-api';
import { StringHelper } from '@/helpers/string';
import { Sex } from '@/types/converter/convert';
import H2 from '@/components/atoms/H2.vue';
import { VueHelper } from '@/helpers/vue';
import { ErrorHelper } from '@/helpers/error';

@Component({
    components: {
        Title,
        BtnBase,
        H2
    },
})
export default class DefaultSignupConfirmation extends Vue {
    @Prop() private request!: CustomerSignupRequest;
    @Prop() private provisionShopCode!: string;

    get nameKanji () {
        return this.request.lastNameKanji + ' ' + this.request.firstNameKanji
    }

    get nameKana () {
        return this.request.lastNameKana + ' ' + this.request.firstNameKana
    }

    get zipCode () {
        return StringHelper.convertDisplayZipCode(this.request.zipCode)
    }

    get address () {
        return this.request.state + this.request.city + this.request.address1 + this.request.address2
    }

    get sex () {
        const sex = Sex.findValue(this.request.sex)
        return sex ? sex.value : ''
    }

    get birthday () {
        return StringHelper.convertDisplayDate(this.request.birthday)
    }

    back () {
        this.$emit('back')
    }

    async signup () {
        this.request.checkOnly = false
        VueHelper.lock()
        const response: any = await this.$api.postCustomerSignup(this.request)
        VueHelper.unlock()

        const apiResult = ErrorHelper.apiErrorHandler(response, this)
        if (apiResult) {
            VueHelper.move(this, '/signup/complete?provision_shop_code=' + this.provisionShopCode)
        } else {
            VueHelper.move(this, '/error')
        }
    }
}
